module.exports = __webpack_public_path__ + "img/icon-edit.5ee166f4.svg";